import { component } from 'picoapp'
import $ from '../lib/quantdom'
import { centsToDollars } from '../lib/utils'

export default component((node) => {
  $(node).on('click', async (e) => {
    const url = new URL(window.location)
    const id = $(e.target)?.attr('data-id')
    const variantId = $(e.target)?.attr('data-variant-id')
    const productData = window.Flavors.find((el) => el.product.id == id)
    const type = $('.js-purchase-type[aria-current="true"]')
      ? $('.js-purchase-type[aria-current="true"]')?.attr('data-value')
      : null
    const { product, subscriptions } = productData
    const variant = product.variants.find((el) => el.id == variantId)

    url.searchParams.set('variant', variant.id)
    history.replaceState({}, '', url)
    $('.js-purchase-type[data-value="one-time"]')?.attr('data-price', variant.price)
    $('.js-one-time-price')?.text('$' + centsToDollars(variant.price, true))
    $('add-button#main-add-to-cart')?.attr('variant-id', variant.id)
    $('.dynamic-payment-button input[name="id"]')?.val(variant.id) //used for dynamic payment/buy now button
    $('.js-size-btn')?.attr('aria-current', false)
    $(e.target).attr('aria-current', true)

    if (subscriptions?.original_to_hidden_variant_map && subscriptions?.original_to_hidden_variant_map[variantId]) {
      const subscriptionPrice = subscriptions?.original_to_hidden_variant_map[variantId]?.discount_variant_price * 100
      $('.js-subscription-price')?.text('$' + centsToDollars(subscriptionPrice, true))
      $('.js-purchase-type[data-value="subscription"]')?.attr('aria-hidden', false).attr('data-price', subscriptionPrice)
    } else {
      $('.js-purchase-type[data-value="subscription"]')?.attr('aria-hidden', true)
    }

    if (type === 'subscription' && subscriptions?.original_to_hidden_variant_map) {
      const subscriptionPrice = subscriptions?.original_to_hidden_variant_map[variantId]?.discount_variant_price * 100
      $('.js-pdp-afterpay')?.attr('data-amount', centsToDollars(subscriptionPrice, true))
      $('.js-product-price')?.text('$' + centsToDollars(subscriptionPrice, true))
    } else {
      $('.js-product-price')?.text('$' + centsToDollars(variant.price, true))
      $('.js-pdp-afterpay')?.attr('data-amount', centsToDollars(variant.price))
    }
  })
})
